/* Atelier Levia – Theme-Skripte */
(function () {
  'use strict';
  var AL = window.AL || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var TZ = 'Europe/Berlin';
  var WD = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var WDS = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
  var MO = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  function nowTZ() { return new Date(new Date().toLocaleString('en-US', { timeZone: TZ })); }
  function z(n) { return (n < 10 ? '0' : '') + n; }
  function money(cents) {
    var v = (cents / 100).toFixed(2).split('.');
    v[0] = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return v[0] + ',' + v[1] + ' €';
  }
  function root() { return (AL.routes && AL.routes.root) || '/'; }

  /* ---------- Overlay / Drawer-Verwaltung ---------- */
  var overlay = $('[data-al-overlay]');
  var openDrawer = null, lastFocus = null;
  function lock(on) { document.body.classList.toggle('al-lock', !!on); }
  function showOverlay(on) { if (overlay) overlay.classList.toggle('is-open', !!on); }
  function openPanel(el, trigger) {
    if (!el) return;
    closePanel();
    lastFocus = trigger || document.activeElement;
    el.classList.add('is-open', 'on');
    el.setAttribute('aria-hidden', 'false');
    openDrawer = el; showOverlay(true); lock(true);
    var f = el.querySelector('button, a, input'); if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closePanel() {
    if (!openDrawer) return;
    openDrawer.classList.remove('is-open', 'on');
    openDrawer.setAttribute('aria-hidden', 'true');
    openDrawer = null; showOverlay(false); lock(false);
    var mt = $('[data-al-menu-open]'); if (mt) mt.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (overlay) overlay.addEventListener('click', closePanel);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closePanel(); closeLightbox(); $$('[data-al-facet].is-open').forEach(function (f) { f.classList.remove('is-open'); }); }
  });

  /* ---------- Kopfbereich ---------- */
  function initHeader() {
    var cd = $('[data-al-cutoff]');
    if (cd) {
      var cut = parseInt(cd.getAttribute('data-al-cutoff'), 10) || 23;
      var tick = function () {
        var n = nowTZ();
        var rem = cut * 3600 - (n.getHours() * 3600 + n.getMinutes() * 60 + n.getSeconds());
        if (rem <= 0) rem += 86400;
        cd.textContent = z(Math.floor(rem / 3600)) + 'H ' + z(Math.floor(rem % 3600 / 60)) + 'M ' + z(rem % 60) + 'S';
      };
      tick(); setInterval(tick, 1000);
    }
    var cp = $('[data-al-copy]');
    if (cp) cp.addEventListener('click', function () {
      var code = ($('[data-al-code]') || {}).textContent || '';
      var b = this, done = function () { b.textContent = b.getAttribute('data-done'); setTimeout(function () { b.textContent = b.getAttribute('data-label'); }, 2000); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code.trim()).then(done, done); else done();
    });
    var pc = $('[data-al-promo-close]');
    if (pc) pc.addEventListener('click', function () { var p = $('[data-al-promo]'); if (p) p.classList.add('off'); try { sessionStorage.setItem('al-promo-off', '1'); } catch (e) {} });
    try { if (sessionStorage.getItem('al-promo-off') === '1') { var p = $('[data-al-promo]'); if (p) p.classList.add('off'); } } catch (e) {}
    var st = $('[data-al-msearch-toggle]');
    if (st) st.addEventListener('click', function () {
      var ms = $('#al-msearch'); var on = ms.classList.toggle('on');
      st.setAttribute('aria-expanded', on ? 'true' : 'false');
      if (on) { var i = ms.querySelector('input[type=search]'); if (i) i.focus(); }
    });
    var mo = $('[data-al-menu-open]'), menu = $('[data-al-menu]');
    if (mo && menu) mo.addEventListener('click', function () { openPanel(menu, mo); mo.setAttribute('aria-expanded', 'true'); });
    $$('[data-al-menu-close]').forEach(function (b) { b.addEventListener('click', closePanel); });
  }

  /* ---------- Vorschläge in der Suche ---------- */
  function initPredictive() {
    $$('[data-al-psearch]').forEach(function (form) {
      var input = form.querySelector('input[type=search]'), box = form.querySelector('[data-al-psr]');
      if (!input || !box) return;
      var t = null, ctrl = null;
      input.addEventListener('input', function () {
        clearTimeout(t);
        var q = input.value.trim();
        if (q.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
        t = setTimeout(function () {
          if (ctrl && ctrl.abort) ctrl.abort();
          ctrl = window.AbortController ? new AbortController() : null;
          fetch(root() + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,page&resources[limit]=5&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
            .then(function (r) { return r.json(); })
            .then(function (d) {
              var res = (d.resources && d.resources.results) || {}, h = '';
              var ps = res.products || [], pg = res.pages || [];
              if (ps.length) {
                h += '<p class="al-ps-head">Produkte</p>';
                ps.forEach(function (p) {
                  var title = (p.title || '').split(' | ')[0];
                  h += '<a class="al-ps-item" href="' + p.url + '">' + (p.image ? '<img src="' + p.image + '&width=128" alt="" width="64" height="64" loading="lazy">' : '') +
                    '<span><span class="al-ps-item__t">' + title + '</span><br><span class="al-ps-item__p">' + (p.price ? String(p.price).replace('.', ',') + ' €' : '') + '</span></span></a>';
                });
              }
              if (pg.length) {
                h += '<p class="al-ps-head">Seiten</p>';
                pg.forEach(function (p) { h += '<a class="al-ps-item" href="' + p.url + '"><span class="al-ps-item__t">' + p.title + '</span></a>'; });
              }
              h += '<a class="al-ps-all" href="' + root() + 'search?q=' + encodeURIComponent(q) + '&options[prefix]=last">Alle Ergebnisse für „' + q.replace(/</g, '&lt;') + '“ anzeigen →</a>';
              if (!ps.length && !pg.length) h = '<p class="al-ps-none">Keine Treffer für „' + q.replace(/</g, '&lt;') + '“.</p>';
              box.innerHTML = h; box.hidden = false;
            }).catch(function () {});
        }, 220);
      });
      document.addEventListener('click', function (e) { if (!form.contains(e.target)) box.hidden = true; });
      input.addEventListener('keydown', function (e) { if (e.key === 'Escape') box.hidden = true; });
    });
  }

  /* ---------- Warenkorb ---------- */
  var drawer = null;
  function updateCounts(n) { $$('[data-al-cart-count]').forEach(function (el) { el.textContent = n; }); }
  function renderDrawer(open) {
    return fetch(root() + '?sections=al-cart-drawer').then(function (r) { return r.json(); }).then(function (s) {
      var html = s['al-cart-drawer']; if (!html) return;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-al-cart-drawer]');
      if (fresh && drawer) drawer.innerHTML = fresh.innerHTML;
      bindDrawer();
      if (open) openPanel(drawer, document.activeElement);
    });
  }
  function refreshCount() { return fetch(root() + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { updateCounts(c.item_count); return c; }); }
  function bindDrawer() {
    if (!drawer) return;
    $$('[data-al-cart-close]', drawer).forEach(function (b) { b.addEventListener('click', closePanel); });
    $$('[data-al-line]', drawer).forEach(function (b) {
      b.addEventListener('click', function () {
        var item = b.closest('.al-cd-item'); if (item) item.style.opacity = '.45';
        fetch(root() + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: b.getAttribute('data-al-line'), quantity: parseInt(b.getAttribute('data-qty'), 10) }) })
          .then(function (r) { return r.json(); }).then(function (c) { updateCounts(c.item_count); return renderDrawer(false); })
          .then(function () { if (drawer && !drawer.classList.contains('is-open')) return; var f = drawer.querySelector('.al-cd-close, .al-cd-x'); if (f) f.focus(); })
          .catch(function () { if (item) item.style.opacity = '1'; });
      });
    });
    var df = $('[data-al-discount-form]', drawer), msg = $('[data-al-discount-msg]', drawer);
    if (df) df.addEventListener('submit', function (e) {
      e.preventDefault();
      var code = (df.querySelector('input').value || '').trim(); if (!code) return;
      fetch(root() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) })
        .then(function (r) { return r.json(); }).then(function (c) {
          var ok = (c.discount_codes || []).some(function (d) { return d.code.toLowerCase() === code.toLowerCase() && d.applicable; });
          return renderDrawer(false).then(function () {
            var m = $('[data-al-discount-msg]', drawer);
            if (m) { m.hidden = false; m.textContent = ok ? 'Rabattcode „' + code + '“ wurde angewendet.' : 'Der Rabattcode „' + code + '“ ist ungültig oder für diesen Warenkorb nicht anwendbar.'; m.className = 'al-cd-discount-msg ' + (ok ? 'is-ok' : 'is-err'); }
          });
        });
    });
    $$('[data-al-discount-remove]', drawer).forEach(function (b) {
      b.addEventListener('click', function () {
        fetch(root() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) }).then(function () { return renderDrawer(false); });
      });
    });
  }
  function addToCart(form, btn) {
    var fd = new FormData(form);
    var msg = form.querySelector('[data-al-form-msg]');
    if (btn) btn.classList.add('is-loading');
    if (msg) msg.hidden = true;
    return fetch(root() + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { return refreshCount(); })
      .then(function () { return renderDrawer(true); })
      .catch(function (err) {
        var t = (err && (err.description || err.message)) || (AL.strings && AL.strings.error) || 'Fehler';
        if (msg) { msg.textContent = t; msg.hidden = false; } else alert(t);
      })
      .then(function () { if (btn) btn.classList.remove('is-loading'); });
  }
  function initCart() {
    drawer = $('[data-al-cart-drawer]');
    bindDrawer();
    $$('[data-al-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { if (!drawer) return; e.preventDefault(); renderDrawer(true); });
    });
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f.matches || !f.matches('[data-al-add]')) return;
      if (!drawer) return;
      e.preventDefault();
      var btn = (e.submitter && e.submitter.closest('form') === f) ? e.submitter : f.querySelector('[type=submit]');
      if (e.submitter && e.submitter.getAttribute('form') === f.id) btn = e.submitter;
      addToCart(f, btn);
    });
  }

  /* ---------- Mengenwähler ---------- */
  function initQty() {
    $$('[data-al-qty]').forEach(function (w) {
      var i = w.querySelector('input');
      $$('button[data-step]', w).forEach(function (b) {
        b.addEventListener('click', function () {
          var min = parseInt(i.getAttribute('min') || '1', 10);
          var v = Math.max(min, (parseInt(i.value, 10) || 0) + parseInt(b.getAttribute('data-step'), 10));
          i.value = v; i.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  /* ---------- Produktgalerie + Lightbox ---------- */
  var lb = null, lbImgs = [], lbIndex = 0;
  function closeLightbox() { if (lb && !lb.hidden) { lb.hidden = true; lock(false); } }
  function showLb(i) {
    if (!lb) return; lbIndex = (i + lbImgs.length) % lbImgs.length;
    var img = lb.querySelector('[data-al-lightbox-img]'); img.src = lbImgs[lbIndex].src; img.alt = lbImgs[lbIndex].alt;
  }
  function initGallery() {
    var g = $('[data-al-gallery]'); if (!g) return;
    var track = $('[data-al-gallery-track]', g), slides = $$('.al-gallery__slide', g), thumbs = $$('.al-gallery__thumb', g), dots = $$('[data-al-gallery-dots] span', g);
    function setActive(i) {
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      var t = thumbs[i]; if (t && t.parentNode) { var p = t.parentNode; if (p.scrollHeight > p.clientHeight) p.scrollTo({ top: t.offsetTop - p.clientHeight / 2 + t.clientHeight / 2, behavior: 'smooth' }); }
    }
    function go(i) { var s = slides[i]; if (!s) return; track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' }); setActive(i); }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return; raf = requestAnimationFrame(function () { raf = null; var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); setActive(Math.min(slides.length - 1, i)); });
    });
    track.addEventListener('keydown', function (e) {
      var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(slides.length - 1, i + 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(0, i - 1)); }
    });
    lb = $('[data-al-lightbox]');
    lbImgs = slides.map(function (s) { var im = s.querySelector('img'); return { src: im ? (im.getAttribute('data-zoom') || im.src) : '', alt: im ? im.alt : '' }; });
    function openLb(i) { if (!lb) return; lb.hidden = false; lock(true); showLb(i); lb.querySelector('[data-al-lightbox-close]').focus(); }
    var zb = $('[data-al-zoom]', g);
    if (zb) zb.addEventListener('click', function () { openLb(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
    slides.forEach(function (s, i) { s.addEventListener('click', function () { if (window.matchMedia('(pointer:fine)').matches) openLb(i); }); });
    if (lb) {
      lb.querySelector('[data-al-lightbox-close]').addEventListener('click', closeLightbox);
      lb.querySelector('[data-al-lightbox-prev]').addEventListener('click', function () { showLb(lbIndex - 1); });
      lb.querySelector('[data-al-lightbox-next]').addEventListener('click', function () { showLb(lbIndex + 1); });
      lb.addEventListener('click', function (e) { if (e.target === lb) closeLightbox(); });
      document.addEventListener('keydown', function (e) { if (lb.hidden) return; if (e.key === 'ArrowRight') showLb(lbIndex + 1); if (e.key === 'ArrowLeft') showLb(lbIndex - 1); });
    }
  }

  /* ---------- Varianten ---------- */
  function initVariants() {
    var data = $('[data-al-variants]'); if (!data) return;
    var variants = JSON.parse(data.textContent), form = $('[data-al-main-form]'); if (!form) return;
    var idInput = form.querySelector('[data-al-variant-id]'), atc = form.querySelector('[data-al-atc]');
    $$('[data-al-option]').forEach(function (r) {
      r.addEventListener('change', function () {
        var sel = [1, 2, 3].map(function (p) { var c = $('[data-al-option="' + p + '"]:checked'); return c ? c.value : null; });
        var v = variants.find(function (x) { return x.options.every(function (o, k) { return sel[k] === null || sel[k] === o; }); });
        if (!v) { if (atc) { atc.disabled = true; atc.textContent = 'Nicht verfügbar'; } return; }
        idInput.value = v.id;
        if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? (AL.strings.addToCart) : AL.strings.soldOut; }
        var pr = $('[data-al-price] .al-price__sale'); if (pr) pr.innerHTML = '<span class="al-sr">Verkaufspreis</span>' + money(v.price);
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u);
        if (v.featured_media) { var s = $('.al-gallery__slide[data-media-id="' + v.featured_media.id + '"]'); if (s) { var t = $('[data-al-gallery-track]'); t.scrollTo({ left: s.offsetLeft - t.offsetLeft, behavior: 'smooth' }); } }
      });
    });
  }

  /* ---------- Lieferschätzung ---------- */
  function addBusinessDays(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; } return x; }
  function fmt(d) { return WD[d.getDay()] + ', ' + d.getDate() + '. ' + MO[d.getMonth()]; }
  function initDelivery() {
    $$('[data-al-delivery]').forEach(function (el) {
      if (el.getAttribute('data-ready')) return; el.setAttribute('data-ready', '1');
      var lim = parseInt(el.getAttribute('data-limite'), 10), mn = parseInt(el.getAttribute('data-min'), 10), mx = parseInt(el.getAttribute('data-max'), 10);
      var dEl = el.querySelector('[data-al-date]'), cEl = el.querySelector('[data-al-count]'), nEl = el.querySelector('[data-al-note]');
      function run() {
        var n = nowTZ();
        var isWorkday = n.getDay() !== 0 && n.getDay() !== 6;
        var cut = new Date(n.getFullYear(), n.getMonth(), n.getDate(), lim, 0, 0);
        var after = !isWorkday || n >= cut;
        var next = new Date(cut); if (n >= cut) next.setDate(next.getDate() + 1);
        while (next.getDay() === 0 || next.getDay() === 6) next.setDate(next.getDate() + 1);
        var rem = Math.max(0, Math.floor((next - n) / 1000));
        if (cEl) cEl.textContent = z(Math.floor(rem / 3600)) + ' H ' + z(Math.floor(rem % 3600 / 60)) + ' M ' + z(rem % 60) + ' S';
        var ship = after ? addBusinessDays(new Date(n.getFullYear(), n.getMonth(), n.getDate()), 1) : new Date(n.getFullYear(), n.getMonth(), n.getDate());
        var a = addBusinessDays(ship, mn), b = addBusinessDays(ship, mx);
        if (dEl) dEl.textContent = (mn === mx) ? fmt(a) : (WDS[a.getDay()] + ' ' + a.getDate() + '.' + (a.getMonth() !== b.getMonth() ? ' ' + MO[a.getMonth()] : '') + ' – ' + WDS[b.getDay()] + ' ' + b.getDate() + '. ' + MO[b.getMonth()]);
        if (nEl) { var want = after ? 'after' : 'before'; if (nEl.getAttribute('data-state') !== want) { nEl.innerHTML = nEl.getAttribute('data-' + want); nEl.setAttribute('data-state', want); } }
      }
      run(); setInterval(run, 1000);
    });
  }
  function initLive() {
    $$('[data-al-live]').forEach(function (el) {
      var o = parseInt(el.getAttribute('data-debut'), 10), c = parseInt(el.getAttribute('data-fin'), 10);
      var dot = el.querySelector('[data-al-live-dot]'), txt = el.querySelector('[data-al-live-txt]'); if (!dot || !txt) return;
      function run() { var h = nowTZ().getHours(), open = h >= o && h < c; dot.setAttribute('data-etat', open ? 'ouvert' : 'ferme'); txt.textContent = open ? 'Jetzt erreichbar' : 'Antwort ab ' + o + ' Uhr'; }
      run(); setInterval(run, 60000);
    });
  }

  /* ---------- Sticky-Kaufleiste ---------- */
  function initSticky() {
    var bar = $('[data-al-sticky]'), form = $('[data-al-main-form]'); if (!bar || !form || !window.IntersectionObserver) return;
    var footer = $('.al-footer');
    var formVisible = true, footerVisible = false;
    function upd() { var on = !formVisible && !footerVisible && form.getBoundingClientRect().top < 0; bar.classList.toggle('is-visible', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); }
    new IntersectionObserver(function (e) { formVisible = e[0].isIntersecting; upd(); }).observe(form);
    if (footer) new IntersectionObserver(function (e) { footerVisible = e[0].isIntersecting; upd(); }).observe(footer);
  }

  /* ---------- Karussells ---------- */
  function initCarousels() {
    $$('[data-al-carousel]').forEach(function (c) {
      var track = c.querySelector('[data-al-car-track]'); if (!track) return;
      var cards = $$('.alcr-card', track), dots = $$('.alcr-dot', c), cur = 0;
      function go(i) { i = Math.max(0, Math.min(i, cards.length - 1)); track.scrollTo({ left: cards[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); cur = i; dots.forEach(function (d, j) { d.classList.toggle('active', j === i); }); }
      $$('.alcr-arrow', c).forEach(function (b) { b.addEventListener('click', function () { go(cur + parseInt(b.getAttribute('data-dir'), 10)); }); });
      dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-idx'), 10)); }); });
      track.addEventListener('scroll', function () {
        var sl = track.scrollLeft, best = 0, bd = 1e9;
        cards.forEach(function (cc, i) { var d = Math.abs(cc.offsetLeft - track.offsetLeft - sl); if (d < bd) { bd = d; best = i; } });
        if (best !== cur) { cur = best; dots.forEach(function (d, j) { d.classList.toggle('active', j === cur); }); }
      }, { passive: true });
    });
    $$('[data-al-reviews]').forEach(function (r) {
      var piste = r.querySelector('[data-al-rv-track]'), pts = r.querySelector('[data-al-rv-pts]'), prev = r.querySelector('[data-al-rv-prev]'), next = r.querySelector('[data-al-rv-next]');
      var cards = $$('.alavis-c', piste); if (cards.length < 2) { if (r.querySelector('.alavis-nav')) r.querySelector('.alavis-nav').style.display = 'none'; return; }
      function step() { return cards[1].offsetLeft - cards[0].offsetLeft; }
      function idx() { return Math.round(piste.scrollLeft / step()); }
      function to(i) { piste.scrollTo({ left: Math.max(0, Math.min(i, cards.length - 1)) * step(), behavior: 'smooth' }); }
      function maj() { var i = idx(); $$('button', pts).forEach(function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); }); prev.disabled = piste.scrollLeft <= 2; next.disabled = piste.scrollLeft >= piste.scrollWidth - piste.clientWidth - 2; }
      cards.forEach(function (c, i) { var b = document.createElement('button'); b.type = 'button'; b.className = 'alavis-pt'; b.setAttribute('aria-label', 'Bewertung ' + (i + 1)); b.addEventListener('click', function () { to(i); }); pts.appendChild(b); });
      prev.addEventListener('click', function () { to(idx() - 1); }); next.addEventListener('click', function () { to(idx() + 1); });
      piste.addEventListener('scroll', function () { clearTimeout(piste._t); piste._t = setTimeout(maj, 60); }); maj();
      if (r.getAttribute('data-colonne') === '1') { var info = $('[data-al-pinfo]'); var sec = r.closest('.shopify-section'); if (info && sec) { info.appendChild(sec); sec.classList.add('alavis-dans-colonne'); } }
    });
  }

  /* ---------- Bilder mit Text (Scroll) ---------- */
  function initScrollImages() {
    $$('[data-al-scrolli]').forEach(function (w) {
      var items = $$('.al-scrolli__item', w), imgs = $$('.al-scrolli__img', w);
      if (!window.IntersectionObserver || !imgs.length) return;
      imgs.forEach(function (im, i) { im.classList.toggle('is-active', i === 0); });
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = items.indexOf(e.target);
          items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); });
          imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); });
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      items.forEach(function (it) { io.observe(it); });
    });
  }

  /* ---------- Leiter-Berater (Quiz) ---------- */
  function initQuiz() {
    $$('[data-al-quiz]').forEach(function (q) {
      var P = [], C;
      try { P = JSON.parse(q.querySelector('[data-q-products]').textContent); C = JSON.parse(q.querySelector('[data-q-config]').textContent); } catch (e) { return; }
      var QS = C.questions, L = C.labels, T = C.txt, body = q.querySelector('[data-q-body]'), bar = q.querySelector('[data-q-bar]'), stepEl = q.querySelector('[data-q-step]');
      var state = { a: {}, s: 0 };
      var IDEAL = { low: { occasionnel: 2.6, regulier: 2.6, quotidien: 2.6 }, mid: { occasionnel: 3.3, regulier: 3.8, quotidien: 4.3 }, high: { occasionnel: 5.0, regulier: 5.6, quotidien: 6.1 } };
      function score(p, a) {
        var s = -Math.abs(p.m - IDEAL[a.h][a.freq]) * 3;
        if (a.type === 'multi') s += p.c === 'multi' ? 10 : -8; else if (p.c === 'multi') s -= 6;
        if (a.type === 'toiture') { if (p.k) s += 4; if (p.f === 'schwarz') s += 1; }
        if (a.type === 'interieur') { if (p.k) s -= 3; if (p.m > 4.5) s -= 2; }
        if (a.finish === 'silber') s += p.f === 'silber' ? 3 : -2;
        if (a.finish === 'schwarz') s += p.f === 'schwarz' ? 3 : -2;
        if (a.freq === 'quotidien' && p.f === 'schwarz') s += 1;
        if (a.freq === 'occasionnel') s -= p.p * 0.002;
        if (!p.a) s -= 100;
        return s;
      }
      function pick(a) { var best = null, bs = -1e9; P.forEach(function (p) { var s = score(p, a); if (s > bs || (s === bs && best && p.p < best.p)) { bs = s; best = p; } }); return best; }
      function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
      function question() {
        var Q = QS[state.s];
        bar.style.width = (state.s / QS.length * 100) + '%';
        stepEl.textContent = T.question + ' ' + (state.s + 1) + ' ' + T.of + ' ' + QS.length;
        var h = '<h3 class="alq-q">' + Q.q + '</h3><div class="alq-opts">';
        Q.o.forEach(function (o) { h += '<button class="alq-opt" type="button" data-v="' + o.v + '"><span class="alq-dot"></span><span><span class="alq-ot">' + o.t + '</span><span class="alq-od">' + o.d + '</span></span></button>'; });
        h += '</div>'; if (state.s > 0) h += '<button class="alq-back" type="button" data-back>' + T.back + '</button>';
        body.innerHTML = h;
        $$('.alq-opt', body).forEach(function (b) { b.addEventListener('click', function () { state.a[Q.key] = b.getAttribute('data-v'); state.s++; if (state.s >= QS.length) result(); else question(); }); });
        var bk = body.querySelector('[data-back]'); if (bk) bk.addEventListener('click', function () { state.s--; question(); });
      }
      function result() {
        bar.style.width = '100%'; stepEl.textContent = T.result;
        var a = state.a, p = pick(a);
        if (!p) { body.innerHTML = '<p>' + T.none + '</p>'; return; }
        var why = T.why + ' <b>' + L[a.h] + '</b>, <b>' + L[a.type] + '</b>, ' + L[a.freq] + (a.finish !== 'egal' ? ', <b>' + L[a.finish] + '</b>' : '') + '.';
        var chips = T.chips.map(function (c) { return '<span class="alq-chip">' + c + '</span>'; }).join('') + (p.k ? '<span class="alq-chip">' + T.hooks + '</span>' : '') + (p.c === 'multi' ? '<span class="alq-chip">' + T.multi + '</span>' : '');
        body.innerHTML = '<div class="alq-res"><div class="alq-res-top">' + T.top + ' <span>' + T.topSpan + '</span></div><div class="alq-res-body">' +
          '<div class="alq-res-img">' + (p.img ? '<img src="' + p.img + '" alt="' + esc(p.t) + '" loading="lazy">' : '') + '</div>' +
          '<div class="alq-res-info"><h3 class="alq-res-name">' + esc(p.t) + '</h3><p class="alq-res-why">' + why + '</p><div class="alq-price">' + p.pf + '</div><div class="alq-chips">' + chips + '</div><a class="alq-cta" href="' + p.url + '">' + T.view + '</a></div></div></div>' +
          '<button class="alq-restart" type="button" data-restart>' + T.restart + '</button>';
        body.querySelector('[data-restart]').addEventListener('click', function () { state = { a: {}, s: 0 }; question(); });
      }
      question();
    });
  }

  /* ---------- Kollektion: Filter ---------- */
  function initFacets() {
    $$('[data-al-facet]').forEach(function (f) {
      var b = f.querySelector('[data-al-facet-toggle]');
      b.addEventListener('click', function (e) { e.stopPropagation(); var on = f.classList.toggle('is-open'); b.setAttribute('aria-expanded', on ? 'true' : 'false'); });
      document.addEventListener('click', function (e) { if (!f.contains(e.target)) { f.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false'); } });
    });
    $$('[data-al-autosubmit]').forEach(function (i) { i.addEventListener('change', function () { var form = i.closest('form'); if (form) { $$('input[type=number]', form).forEach(function (n) { if (!n.value) n.disabled = true; }); form.submit(); } }); });
    $$('[data-al-facets]').forEach(function (form) { form.addEventListener('submit', function () { $$('input[type=number]', form).forEach(function (n) { if (!n.value) n.disabled = true; }); }); });
  }

  /* ---------- Empfehlungen ---------- */
  function initRelated() {
    var r = $('[data-al-related]'); if (!r || r.children.length) return;
    fetch(r.getAttribute('data-url')).then(function (x) { return x.text(); }).then(function (h) {
      var t = document.createElement('div'); t.innerHTML = h; var n = t.querySelector('[data-al-related]'); if (n && n.innerHTML.trim()) r.innerHTML = n.innerHTML;
    }).catch(function () {});
  }

  /* ---------- Sanftes Scrollen ---------- */
  function initScrollTo() {
    $$('[data-al-scrollto]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.querySelector(a.getAttribute('href')); if (!t) return; e.preventDefault();
        window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 12, behavior: 'smooth' });
        var box = t.querySelector('.alp-fbox'); if (box) { box.classList.remove('flash'); void box.offsetWidth; box.classList.add('flash'); setTimeout(function () { box.classList.remove('flash'); }, 1600); }
      });
    });
  }

  function init() {
    initHeader(); initPredictive(); initCart(); initQty(); initGallery(); initVariants(); initDelivery(); initLive();
    initSticky(); initCarousels(); initScrollImages(); initQuiz(); initFacets(); initRelated(); initScrollTo();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { initQuiz(); initCarousels(); initDelivery(); initGallery(); });
})();
